<template>
  <div class="flex flex-col gap-y-[24px]">

    <CommonSettingsPart
      v-model="stepFormData"
      :nosologyList="nosologyList"
      :assignmentTemplateList="assignmentTemplateList"
      :fullKzsFormData="fullKzsFormData"
    />
    <AdditionalSettingsPart v-model="isPressureKzsModel" />

    <div class="flex gap-x-[8px]">
      <VButton type="light" label="Назад" @click="prevStepHandler" size="m" />
      <VButton type="primary" label="Далее" @click="nextStepHandler" size="m" :disabled="isNextButtonDisabled" />
    </div>
  </div>
</template>

<script>
import { VButton } from '@gostelemed.front/rt-doctis.designsystem';

import AdditionalSettingsPart from './FormParts/AdditionalSettingsPart.vue';
import CommonSettingsPart from './FormParts/CommonSettingsPart.vue';

export default {
  name: 'CreateKzsFormStep1',
  components: {
    VButton,
    AdditionalSettingsPart,
    CommonSettingsPart,
  },
  props: {
    nosologyList: {
      type: Array,
      required: true,
    },
    assignmentTemplateList: {
      type: Array,
      required: true,
    },
    fullKzsFormData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      stepFormData: {
        name: null,
        nosologyId: null,
        assignmentTemplateId: null,
        description: '',
        subType: 0
      },
      isPressureKzs: false,
    }
  },
  watch: {
    fullKzsFormData: {
      immediate: true,
      handler(newValue) {
        if (!newValue || !Object.keys(newValue).length) return;
        this.isPressureKzs = newValue.subType === 1;
      },
    },
  },
  computed: {
    isPressureKzsModel: {
      get() {
        return this.isPressureKzs
          ? [{ id: 'kzs-is-pressure-kzs-mode' }]
          : [];
      },
      set(payload) {
        this.isPressureKzs = Array.isArray(payload)
          ? payload.some((item) => item?.id === 'kzs-is-pressure-kzs-mode')
          : false;
      }
    },
    isNextButtonDisabled() {
      return !this.stepFormData.name || !this.stepFormData.assignmentTemplateId || !this.stepFormData.nosologyId;
    },
  },
  methods: {
    // Подготовка данных для передачи на следующий шаг
    prepareDataForNextStep() {
      return {
        nosologyId: this.stepFormData.nosologyId?.id,
        assignmentTemplateId: this.stepFormData.assignmentTemplateId?.id,
        name: this.stepFormData.name,
        description: this.stepFormData.description,
        subType: this.isPressureKzs ? 1 : 0,
      }
    },
    // Сохранение данных для передачи на следующий шаг
    saveStepResult() {
      const data = this.prepareDataForNextStep();
      this.$emit('on-save-data', data);
    },
    // Переход на предыдущий шаг
    prevStepHandler() {
      this.saveStepResult();
      this.$emit('on-prev-step');
    },
    // Переход на следующий шаг
    nextStepHandler() {
      this.saveStepResult();
      this.$emit('on-next-step');
    },
  },
}
</script>

<style lang="scss">
label {
  margin-bottom: 0 !important;
}
.border {
  border: none !important;
}
</style>
